module.exports = __webpack_public_path__ + "static/media/buildingConstruction27.737744a5.jpg";